wbApp.directive('wbActionCombo', ['$timeout', '$translate', '$filter', 'courseSvc',
    function ($timeout, $translate, $filter, courseSvc) {
        function formatResult(course) {
            if (!course) { return; }

            return "<div class='row'>" +
                        "<div class='col-md-9'>" + $filter('courseFullName')(course) + "</div>" +
                        "<div class='col-md-2'>" + (!!course.firstLesson ? $filter('date')(course.firstLesson, 'EEE HH:mm').toUpperCase() : '') + "</div>" +
                        "<div class='col-md-1'>" + course.filled + "/" + course.capacity + "</div>" +
                    "</div>";
        }

        function formatSelection(course) {
            return $filter('courseFullName')(course);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                semesterId: '=',
            },
            link: function (scope, elm, attrs, ctrl) {

                var courses = courseSvc.getAllActionsAsync(scope.semesterId, true);

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_COURSE'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        id: function (course) { return course.courseID; },
                        data: courses
                    });

                    ctrl.$render();
                });

                ctrl.$render = function () {
                    courses.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                scope.$watch('semesterId', function (newValue) {
                    var newCourses = courseSvc.getAllActionsAsync(newValue);
                    newCourses.$promise.then(function () {
                        if (newCourses !== courses) {
                            courses.length = 0;
                            courses.push.apply(courses, newCourses);
                        }

                        for (var i = 0; i < courses.length; i++) {
                            if (courses[i].courseID == ctrl.$viewValue) {
                                return;
                            }
                        }

                        $(elm).select2('val', null);
                        ctrl.$setViewValue(null);
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);